import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { hyphenToCamelCase } from '../../store/utils'

const DynamicTitle = () => {
  const location = useLocation()
  const { t } = useTranslation()

  const getTitle = () => {
    const baseTitle = 'BeeCrew'
    const currentPage = location.pathname

    if (!currentPage || currentPage === '/') return baseTitle

    return `${baseTitle} - ${t(`page.name.${hyphenToCamelCase(currentPage.substring(1))}`)}`
  }

  return (
    <>
      <Helmet>
        <title>{getTitle()}</title>
      </Helmet>
      <Outlet/>
    </>
  )
}

export default DynamicTitle
